export const AboutSection = () => {
  const features = [
    {
      
      description:
        "Teirrax is designed to simplify trading with AI-powered bots, real-time market insights, and advanced security. Whether you prefer manual trading or want to let automation handle the work, our platform gives you the tools to succeed.",
    },
    {
      
      description:
        "With cutting-edge technology and a user-friendly interface, Teirrax makes trading accessible for beginners and professionals. We believe in smart, secure, and efficient trading, helping you maximize profits with minimal effort",
    },
    {
      
      description:"We combine traditional trading strategies with modern AI-driven solutions to create a seamless experience. Our smart algorithms analyze market trends, execute trades efficiently, and minimize risks, allowing you to trade with confidence."
    },
    {
      
      description:"We are committed to innovation, security, and transparency, ensuring that every trader—whether a beginner or an expert—has access to reliable tools and insights. Our goal is to empower you with a powerful, automated, and secure trading environment for long-term success. "
    },
   
  ];

  const images = [
    "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
  ];

  return (
    <div className="px-4 py-6 max-w-7xl  mx-auto ">
      <div className="max-w-3xl mb-10 md:mx-auto sm:text-center  md:mb-12">
        <p className="inline-block px-3 py-px mb-2 bg-blue-100  text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
          About
        </p>
        <h2 className="mb-2 text-4xl font-semibold leading-none tracking-tight text-gray-900 md:mx-auto">
        About Teirrax 
        </h2>
        <p className="text-base text-gray-700 md:text-lg">
        Bringing AI technology and automation to make trading easier, faster, and more profitable.        </p>
      </div>

      <div className="grid  gap-8 lg:grid-cols-2 sm:mx-auto">
        <div className="flex flex-col justify-center">
          {features.map((feature, index) => (
            <div className="flex" key={index}>
              <div className="mr-4">
                <div className="flex items-center justify-center w-10 h-10 mb-3 rounded-full bg-indigo-50">
                  <svg
                    className="w-8 h-8 text-deep-purple-accent-400"
                    stroke="currentColor"
                    viewBox="0 0 52 52"
                  >
                    <polygon
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                      points="29 13 14 29 25 29 23 39 38 23 27 23"
                    />
                  </svg>
                </div>
              </div>
              <div>
                <h6 className="mb-2 font-semibold leading-5">{feature.title}</h6>
                <p className="text-sm text-gray-900">{feature.description}</p>
                {index !== features.length - 1 && <hr className="w-full my-6 border-gray-300" />}
              </div>
            </div>
          ))}
        </div>

        {/* Right Column - Images */}
        <div className="grid grid-cols-2 gap-5">
          {images.map((image, index) => (
            <img
              key={index}
              className={`object-cover w-full ${
                index === 0 ? "h-56 col-span-2" : "h-48"
              } rounded shadow-lg`}
              src={image}
              alt=""
            />
          ))}
        </div>
      </div>
    </div>
  );
};
